import { ReactElement } from 'react';
import { FilterLine, FilterTreeChildren } from './FilterLine';
import { FilterRowForm } from './FilterRowForm';
import type { FilterGroupProps } from './types';

/** A group: its rows on a bracket of their own with the AND / OR pill. */
export function FilterGroup({
  group: { groupId, logicOperator, rows },
  onChangeLogicOperator,
  ...rowFormProps
}: FilterGroupProps): ReactElement {
  return (
    <FilterTreeChildren
      logicOperator={logicOperator}
      onChangeLogicOperator={(selected) => onChangeLogicOperator(groupId, selected)}
      items={rows.map((row) => ({
        key: row.id,
        kind: 'row',
        content: (
          <FilterLine onRemove={() => rowFormProps.onRemove(row)}>
            <FilterRowForm row={row} {...rowFormProps} />
          </FilterLine>
        ),
      }))}
    />
  );
}
